import { graphql, useStaticQuery } from "gatsby"
import * as React from "react"
import BlogCardGrid, {
  IBlogCard,
} from "../../design-system/templates/blog-card-grid"
import { IFluidImageQuery } from "../../design-system/types/imageQuery.types"
import ExternalLinks from "../../external-links"

interface IIndoorMappingBlogFeaturesStaticQuery {
  createMapsMobile: IFluidImageQuery
  createMapsTablet: IFluidImageQuery
  createMapsDesktop: IFluidImageQuery
  maintainingMapsMobile: IFluidImageQuery
  maintainingMapsTablet: IFluidImageQuery
  maintainingMapsDesktop: IFluidImageQuery
  mapEditorMobile: IFluidImageQuery
  mapEditorTablet: IFluidImageQuery
  mapEditorDesktop: IFluidImageQuery
}

export default function BlogFeatures() {
  const {
    createMapsMobile,
    createMapsTablet,
    createMapsDesktop,
    maintainingMapsMobile,
    maintainingMapsTablet,
    maintainingMapsDesktop,
    mapEditorMobile,
    mapEditorTablet,
    mapEditorDesktop,
  } = useStaticQuery<IIndoorMappingBlogFeaturesStaticQuery>(graphql`
    query {
      # CREATE MAPS
      createMapsMobile: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/blog/mobile blog image 01.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 328) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      createMapsTablet: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/blog/tablet blog image 01.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 598) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      createMapsDesktop: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/blog/desktop blog image 01.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 374) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      # MAINTAINING MAPS
      maintainingMapsMobile: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/blog/desktop blog image 02.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 328) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      maintainingMapsTablet: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/blog/desktop blog image 02.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 598) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      maintainingMapsDesktop: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/blog/desktop blog image 02.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 374) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      # MAP EDITOR
      mapEditorMobile: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/blog/desktop blog image 03.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 328) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mapEditorTablet: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/blog/desktop blog image 03.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 598) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mapEditorDesktop: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/blog/desktop blog image 03.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 374) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const blogCardDetails: IBlogCard[] = [
    {
      imageVariants: {
        sm: createMapsMobile.childImageSharp.fluid,
        md: createMapsTablet.childImageSharp.fluid,
        lg: createMapsDesktop.childImageSharp.fluid,
      },
      title: "How to Create Indoor Maps with Mappedin",
      description:
        "Creating digital indoor maps can be simple when working with the right provider. Here’s how to use Mappedin to create interactive mapping experiences.",
      link: ExternalLinks.hubspot.indoorMapping.createMaps,
    },
    {
      imageVariants: {
        sm: maintainingMapsMobile.childImageSharp.fluid,
        md: maintainingMapsTablet.childImageSharp.fluid,
        lg: maintainingMapsDesktop.childImageSharp.fluid,
      },
      title: "Guide to Maintaining Maps with Mappedin",
      description:
        "An outdated map can leave visitors feeling lost, confused, and frustrated. Here’s how Mappedin makes map maintenance easy.",
      link: ExternalLinks.hubspot.indoorMapping.maintainingMaps,
    },
    {
      imageVariants: {
        sm: mapEditorMobile.childImageSharp.fluid,
        md: mapEditorTablet.childImageSharp.fluid,
        lg: mapEditorDesktop.childImageSharp.fluid,
      },
      title: "Product 101: Map Editor",
      description:
        "Curious about how indoor mapping works? Let's start with our Map Editor, the backbone of Mappedin’s platform.  What is it, how does it work, and why will it help your business?",
      link: ExternalLinks.hubspot.indoorMapping.product101MapEditor,
    },
  ]

  return (
    <>
      <BlogCardGrid
        title="Learn More About Indoor Mapping on our Blog"
        blogCardDetails={blogCardDetails}
      />
    </>
  )
}
